import { FaMicrophoneAlt, FaClock, FaUsers, FaDollarSign } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaMicrophoneAlt />, // Microphone icon for Insightful Talks
        title: 'STEAM ROBOTICS',
        description: 'Top createive and innovative robotic games',
    },
    {
        id: 2,
        icon: <FaClock />, // Clock icon for 24/7 Access
        title: 'INTERNATIONAL',
        description: 'More than 6 countries support WRG',
    },
    {
        id: 3,
        icon: <FaUsers />, // Users icon for Networking
        title: 'All Ages',
        description: 'We have Junior, Senior and Open Game Categories, welcome from age 11+ join WRG ',
    },
    {
        id: 4,
        icon: <FaDollarSign />, // Dollar sign icon for Affordable Pricing
        title: 'AI Robotics',
        description: 'Main theme of 2025, Integrate AI computing power into Robotic games',
    },
];

export default features;